import { render, staticRenderFns } from "./UserAssociatedCustomers.vue?vue&type=template&id=98f11200&"
import script from "./UserAssociatedCustomers.vue?vue&type=script&lang=ts&"
export * from "./UserAssociatedCustomers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports